
export const firebaseConfig = {
    apiKey: 'AIzaSyBRayD6u9oTleUG__ISQjfKavN-5OXINuU',
    authDomain: 'tree-hub-app.firebaseapp.com',
    databaseURL: 'https://tree-hub-app.firebaseio.com',
    projectId: 'tree-hub-app',
    storageBucket: 'tree-hub-app.appspot.com',
    messagingSenderId: '873309221995',
  };